<!-- 盘点历史 -->

<template>
    <div class="reward">
        <div class="tableConBox">
            <div class="tableTem" @click="searchList=[]">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <div class="change-type" v-if="searchByWhichType=='dayOrMonth'">
                            <span @click="nowType='day'">按日查询</span>
                            <span :class="nowType=='day'?'type-wrap':'type-wrap to-right'" @click="nowType=='day'?nowType='month':nowType='day'" >
                                <i @click.stop=""></i>
                            </span>
                            <span @click="nowType='month'">按月查询</span>
                        </div>
                        <div class="month-filter" v-if="nowType=='month'&&searchByWhichType=='dayOrMonth'">
                            <el-date-picker
                            v-model="valueForMonth"
                            value-format="yyyy-MM"
                            format="yyyy 年 MM 月"
                            :picker-options="pickerOptions0"
                            type="month"
                            class="dateTime"
                            placeholder="选择月">
                            </el-date-picker>
                        </div>
                        <div class="day-filter" v-if="nowType=='day'&&searchByWhichType=='dayOrMonth'">
                            <el-date-picker
                            v-model="nowDay"
                            type="date"
                            placeholder="选择日期"
                            format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy-MM-dd"
                            class="dateTime"
                            :picker-options="pickerOptionsForDay"
                            >
                            </el-date-picker>
                        </div>
                        <div class="time-range-filter" v-if="searchByWhichType=='timeRange'">
                            <el-date-picker
                            v-model="startTime"
                            type="datetime"
                            class="dateTime"
                            default-time="00:00:00"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="开始时间">
                            </el-date-picker>
                            <el-date-picker
                            v-model="endTime"
                            type="datetime"
                            class="dateTime"
                            default-time="23:59:59"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="结束时间">
                            </el-date-picker>
                        </div>
                        <span class="types typesSearch">
                            员工：
                            <el-select v-model="judge" placeholder="请选择">
                                <el-option
                                :key="0"
                                label="全部"
                                value="ALL">
                                </el-option>
                                <el-option
                                v-for="item in empList"
                                :key="item.value"
                                :label="item.empName"
                                :value="item.empId">
                                </el-option>
                            </el-select>
                        </span>
                        <span class="types typesSearch">
                            <span type="button" @click="searchConfirm">查询</span>
                        </span>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:25%;text-align: left;">序号</th>
                                <th style="width:30%">会员名称</th>
                                <th style="width:20%">金额</th>
                                <th style="width:15%">员工姓名</th>
                                <th style="width:10%">数量</th>
                            </tr>
                        </table>
                        <div class="scrollBox"  v-if="nowType=='day'&&searchByWhichType=='dayOrMonth'">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:rewardData.length>10}" v-if="rewardData.length>0">
                                    <tr v-for="(item,ind) in rewardData" :key="ind">
                                        <td style="width:25%;text-align: left;" >
                                            <span v-text="ind+1" ></span>
                                        </td>
                                        <td style="width:30%;" v-text="item.name"></td>
                                        <td style="width:20%">{{item.amount | toFixedNum}}</td>
                                        <td style="width:15%" v-text="item.empName"></td>
                                        <td style="width:10%" v-text="item.qty"></td>
                                    </tr>
                                </table>
                                <div class="no-data" v-else>
                                    暂无记录，请点击查询或者重新选择查询条件。
                                </div>
                            </div>
                        </div>
                        <div class="tableBox scrollBox tableBox-for-month" v-if="nowType=='month'&&searchByWhichType=='dayOrMonth'">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:rewardDataForMonth.length>10}" v-if="rewardDataForMonth.length>0">
                                    <tr v-for="(item,ind) in rewardDataForMonth" :key="ind">
                                         <td style="width:25%" >
                                            <span v-text="ind+1" ></span>
                                        </td>
                                        <td style="width:30%;" v-text="item.name"></td>
                                        <td style="width:20%">{{item.amount | toFixedNum}}</td>
                                        <td style="width:15%" v-text="item.empName"></td>
                                        <td style="width:10%" v-text="item.qty"></td>
                                    </tr>
                                </table>
                                <div class="no-data" v-else>
                                    暂无记录，请点击查询或者重新选择查询条件。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 分页器 -->
                <div class="pager flex flex-align-center" v-if="nowType=='day'&&searchByWhichType=='dayOrMonth'">
                    <div class="pagerCon clearfix">
                        <span class="left item">数量:<span class="num color3" v-text="allQty"></span></span>
                        <span class="left item">总收入:<span class="num color5">{{allAmount | toFixedNum}}</span></span>
                    </div>
                </div>
                <div class="pager flex flex-align-center" v-if="nowType=='month'&&searchByWhichType=='dayOrMonth'">
                    <div class="pagerCon clearfix">
                        <span class="left item">数量:<span class="num color3" v-text="allQtyForMonth"></span></span>
                        <span class="left item">总收入:<span class="num color5">{{allAmountForMonth | toFixedNum}}</span></span>
                    </div>
                </div>
            
            </div>
        </div>
        <table id="scrollBox" style="display:none"> 
        </table>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import {BASE_URL,API_BASE_URL} from "./../../../../urlConfig/index";
    export default{
        props:['curStoreId', 'pageSize'],
        data () {
            return {
                judge:"ALL",
                empList:[],//员工列表
                searchByWhichType:"dayOrMonth",//按照时间段或者是按月份。按日的形式查询，dayOrMonth,timeRange，时间段暂时没有
                valueForMonth:'',//月份信息
                allAmount:0,//总金额
                allQtyForMonth:0,//按月份总数量
                allAmountForMonth:0,
                allQty:0,//总数量
                nowDay:'',//当前日期
                nowType:"day",//当前查询方式，如日报，按月份
                rewardData:[],
                rewardDataForMonth:[],
                getBtn: true, // 控制翻页请求
                pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                
                pickerOptionsForDay: {
                //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                
                timeFrom:'',//开始时间
                timeTo:'',//截止时间
                searchList: [], // 搜索结果数组
                goodSearchBtn: true, // 控制搜索框
                canSearch: true, //
                options:[] 
            }
        },
        methods: {
            // 搜索
            searchConfirm: function () {
                let date = new Date(this.nowDay).Format("yyyy-MM-dd");
                let dateForMonth = new Date(this.valueForMonth);
                let dateForMonthObj ={
                    year:dateForMonth.getFullYear(),
                    month:dateForMonth.getMonth() + 1
                }
                
                if(this.searchByWhichType === "dayOrMonth"){
                    if(this.nowType=='month'){
                        if(dateForMonth){
                            this.getRewardData(dateForMonthObj,"MONTH",this.judge);
                        } else {
                            this.$message({
                                message: '请选择查询时间',
                                customClass: 'error'
                            })
                        }
                    }else{
                        if(date){
                            this.getRewardData(date,"DAY",this.judge);
                        } else {
                            this.$message({
                                message: '请选择查询时间',
                                customClass: 'error'
                            })
                        }
                    }
                }
            },
            getRewardData(date,source,judge){
                let params;
                if(this.searchByWhichType === "dayOrMonth"){
                    if(source=="DAY"){
                        params = {
                            storeId:this.curStoreId,
                            from:date,
                            type:"STORE",
                            source,
                            judge
                        }
                        // 
                        let timeStr = new Date(date).getTime() + "-"+judge+"-" + new Date(date).getTime();
                        let nowTime = new Date().getTime();
                        if(!(this.$canClickSelect("rewardInfoDay",timeStr,nowTime))){
                            this.$message({
                                message: '5秒内禁止重复查询相同数据',
                                customClass: 'error'
                            });
                            return;
                        }
                        //
                    }else{
                        params = {
                            storeId:this.curStoreId,
                            year:date.year,
                            month:date.month,
                            type:"STORE",
                            source,
                            judge
                        }
                        // 
                        let timeStr = new Date(date.year+"-"+date.month+"-01").getTime() + "-"+judge+"-" + new Date(date.year+"-"+date.month+"-01").getTime();
                        let nowTime = new Date().getTime();
                        if(!(this.$canClickSelect("rewardInfoMonth",timeStr,nowTime))){
                            this.$message({
                                message: '5秒内禁止重复查询相同数据',
                                customClass: 'error'
                            });
                            return;
                        }
                        //
                    }
                }
                this.$http({
                    url:API_BASE_URL+"v1/clerk/get-reward",
                    method:"GET",
                    params
                }).then(res=>{
                    console.log(res);
                    if(this.searchByWhichType === "dayOrMonth"){
                        if(source == "DAY"){
                            this.rewardData = res.data.rews;
                            this.allAmount = res.data.total;
                            this.allQty = res.data.count;
                        }else{
                            this.rewardDataForMonth = res.data.rews;
                            this.allAmountForMonth = res.data.total;
                            this.allQtyForMonth = res.data.count; 
                        }
                    }
                });
            },
            // 获取员工列表
            getEmpList(){
                this.$http({
                    url:API_BASE_URL+"v1/clerk/get-empRe",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId
                    }
                }).then(res=>{
                    this.empList = res.data;
                });
            }
        },
        activated: function () {
            this.nowDay = new Date();
            this.valueForMonth = new Date();
            this.getEmpList();
        }
    }
</script>
<style lang="scss">
    @import '../../../../../static/css/common.scss';
    @import '../../../tableTemplate/tableTem.scss';
    @import "./rewardInfo.scss";
</style>



// WEBPACK FOOTER //
// rewardInfo.vue?06632e9f